import { createSelector } from '@reduxjs/toolkit';
import { selectClientState } from '../../store/selectors';

export const selectCapitalGainsLosses = createSelector(
  selectClientState,
  (clientState) => clientState.capitalGainsAndLosses
);
